'use client'

import { useMyAccountCardVariant } from '../_hooks/use-my-account-card-variant'
import { CardSkeleton } from './card'
import { MyAccountEmptyBlock } from './empty-block'
import { useRecentlyViewedProductsData } from '../_hooks/use-recently-viewed-products-data'
import { ProductBoxSlider } from './product-box'

export function MyAccountRecentlyViewed() {
  const { title, description } = useMyAccountCardVariant('recently-viewed')
  const { products, isLoading } = useRecentlyViewedProductsData()

  if (isLoading) {
    return <CardSkeleton />
  }
  if (!products?.length) {
    return <MyAccountEmptyBlock variant="recently-viewed" />
  }
  return <ProductBoxSlider products={products} title={title} description={description} />
}
